(function () {
  var f = document.querySelector('.snf');
  if (!f || f.dataset.ready) return;
  f.dataset.ready = '1';
  f.classList.add('js'); /* lists collapse on phones only when JS runs */
  f.querySelectorAll('.snf-col h3 button').forEach(function (b) {
    b.addEventListener('click', function () {
      var col = b.closest('.snf-col');
      var open = !col.classList.contains('is-open');
      col.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  var mq = window.matchMedia('(min-width: 900px)');
  function syncMode() { /* desktop: lists always open, headings not interactive */
    f.querySelectorAll('.snf-col h3 button').forEach(function (b) {
      if (mq.matches) { b.setAttribute('aria-expanded', 'true'); b.tabIndex = -1; }
      else { b.setAttribute('aria-expanded', b.closest('.snf-col').classList.contains('is-open') ? 'true' : 'false'); b.tabIndex = 0; }
    });
  }
  syncMode();
  if (mq.addEventListener) mq.addEventListener('change', syncMode);
  if (/[?&]customer_posted=true/.test(location.search) || f.querySelector('.snf-msg')) {
    var n = f.querySelector('.snf-news'); if (n) n.scrollIntoView({ block: 'center' });
  }
})();
